export const getBackendHost = () => {
    return window.location.hostname === 'corp.togas.com' ? 'api.corp.togas.com' : window.location.hostname;
};
